import { useContext } from 'react';

import { WemapContext } from '../WemapProvider';

export function useWemap() {
    const context = useContext(WemapContext);

    if (context === undefined) {
        throw new Error('useWemap must be used within WemapProvider');
    }
    return context;
}
